var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0266 9.02222L19.8535 15.2222C19.5649 15.6444 20.1199 16.1556 20.5194 15.8L24.626 12.2222C24.737 12.1333 24.8923 12.2 24.8923 12.3556V23.5333C24.8923 23.6889 24.6926 23.7556 24.6038 23.6444L12.1731 8.75556C11.7736 8.26667 11.1964 8 10.5527 8H10.1088C8.9545 8 8 8.95556 8 10.1333V25.8667C8 27.0444 8.9545 28 10.131 28C10.8635 28 11.5516 27.6222 11.9512 26.9778L16.1243 20.7778C16.4129 20.3556 15.8579 19.8444 15.4584 20.2L11.3518 23.7556C11.2408 23.8444 11.0855 23.7778 11.0855 23.6222V12.4667C11.0855 12.3111 11.2852 12.2444 11.374 12.3556L23.8047 27.2444C24.2042 27.7333 24.8036 28 25.4251 28H25.869C27.0455 28 28 27.0444 28 25.8667V10.1333C28 8.95556 27.0455 8 25.869 8C25.1143 8 24.4262 8.37778 24.0266 9.02222Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/near.14cf685e94a4ca685d370b44c57555c7.svg";
export { ForwardRef as ReactComponent };